import { useState, FC } from 'react';
import { Calendar } from 'react-date-range';
import IActivityCountCalendarProps from './models/activity-count-calendar.props';

const TODAY = new Date();

const ActivityCountCalendar: FC<IActivityCountCalendarProps> = ({ date, onClose, onDateSet }) => {
  const [selectedDate, setSelectedDate] = useState<Date>(date);

  const handleDateSelect = (value: Date) => setSelectedDate(value as Date);
  const handleSetClick = () => onDateSet(selectedDate);

  return (
    <div className="activity-count__calendar">
      <Calendar
        date={selectedDate || TODAY}
        onChange={handleDateSelect}
        maxDate={TODAY}
      />
      <footer className="glu-modal__footer">
        <div className="glu-flex-grow glu-flex-row">
          <div className="glu-flex-grow text-right">
            <button className="glu-btn glu-btn--secondary" onClick={onClose} >Cancel</button>
          </div>
          <div className="glu-flex-shrink">
            <button className="glu-btn glu-btn--primary" onClick={handleSetClick}>Set</button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ActivityCountCalendar;